import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
  cx: "16",
  cy: "17",
  r: "1",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 10h12v2H3zM3 14h8v2H3zM3 6h12v2H3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 14.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5v8.18zM16 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
})), 'QueueMusicTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/QueueMusicTwoTone.js
// module id = 5647
// module chunks = 2